import {
  getSize,
  getSvgSize
} from '@components/common/base/buttons/icon-button/icon-button-utils'
import {Size} from '@components/common/base/buttons/types'
import {
  IconTabler,
  TablerIcons
} from '@components/common/icon-tabler/icon-tabler'
import React from 'react'
import tw from 'tailwind-styled-components'

export type TwProps = {
  $size: Size
  $active?: boolean
}

const TwIconButton = tw.div<TwProps>`
  ${p => getSize(p.$size)}
  cursor-pointer
  select-none
  flex
`

export interface IconProps {
  size?: Size
  icon: TablerIcons
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  className?: string
  title?: string
  active?: boolean
}

export const MenuIconButtonBase = (props: IconProps) => {
  const {icon, size, ...rest} = props
  const svgSize = getSvgSize(size)

  return (
    <TwIconButton $size={size} {...rest}>
      <IconTabler
        customSize={svgSize}
        icon={icon}
        viewBox="0 0 24 24"
        className={`flex-none `}
        type="main-menu"
      />
    </TwIconButton>
  )
}
